<template>
  <div class="reactor-container">
    <!-- 视频背景 -->
    <div class="video-background">
      <video autoplay muted playsinline>
        <source src="../../assets/video/reactorbg.mp4" type="video/mp4" />
      </video>
    </div>

    <!-- 主内容 -->
    <div class="main-content">
      <!-- 标题区域 -->
      <div class="header" ref="headerRef">
        <h1 ref="mainTitleRef"> {{ t("home.reactor.title") }}</h1>
        <p class="subtitle" ref="subtitleRef">
          The World First Cell-Free Protein Synthesis Bioreators
        </p>
        <p class="description" ref="descriptionRef">
          {{ t("home.reactor.sedtitle") }}<br/>
         {{ t("home.reactor.sedtitle2") }}
        </p>
      </div>
      <div class="gmp-icon">
        <img src="../../assets/image/home/GMP.png" alt="">
      </div>
      <!-- 反应器展示区域 -->
      <div class="reactors-section">
        <!-- Reactor 10 -->
        <div class="reactor-item reactor-item-1" :class="{ 'active': activeReactorIndex === 0 }"
          @mouseenter="() => handleMouseEnter(0)" @mouseleave="() => handleMouseLeave(0)" @click="() => handleClick(0)"
          :ref="el => reactorRefs[0] = el">
          <div class="reactor-label">
            <div class="reactor-label-corners">
              <span class="corner-top-left"></span>
              <span class="corner-top-right"></span>
              <span class="corner-bottom-left"></span>
              <span class="corner-bottom-right"></span>
              <h3 :ref="el => titleRefs[0] = el">Reactor 10</h3>
              <p :ref="el => descRefs[0] = el">Small-Scale, GMP</p>
            </div>
          </div>
          <div class="reactor-image">
            <img src="../../assets/image/home/reactor10.png" alt="Reactor 10" />
          </div>
          <!-- 人物图片容器 -->
          <div class="reactor-people" v-show="activeReactorIndex === 0">
            <img src="../../assets/image/home/people.png" alt="People" />
          </div>
        </div>

        <!-- Reactor 100 -->
        <div class="reactor-item reactor-item-2" :class="{ 'active': activeReactorIndex === 1 }"
          @mouseenter="() => handleMouseEnter(1)" @mouseleave="() => handleMouseLeave(1)" @click="() => handleClick(1)"
          :ref="el => reactorRefs[1] = el">
          <div class="reactor-label">
            <div class="reactor-label-corners">
              <span class="corner-top-left"></span>
              <span class="corner-top-right"></span>
              <span class="corner-bottom-left"></span>
              <span class="corner-bottom-right"></span>
              <h3 :ref="el => titleRefs[1] = el">Reactor 100</h3>
              <p :ref="el => descRefs[1] = el">Pilot-Scale, GMP</p>
            </div>
          </div>
          <div class="reactor-image">
            <img src="../../assets/image/home/reactor100.png" alt="Reactor 100" />
          </div>
          <!-- 人物图片容器 -->
          <div class="reactor-people" v-show="activeReactorIndex === 1">
            <img src="../../assets/image/home/people.png" alt="People" />
          </div>
        </div>

        <!-- Reactor 1000 -->
        <div class="reactor-item reactor-item-3" :class="{ 'active': activeReactorIndex === 2 }"
          @mouseenter="() => handleMouseEnter(2)" @mouseleave="() => handleMouseLeave(2)" @click="() => handleClick(2)"
          :ref="el => reactorRefs[2] = el">
          <div class="reactor-label">
            <div class="reactor-label-corners">
              <span class="corner-top-left"></span>
              <span class="corner-top-right"></span>
              <span class="corner-bottom-left"></span>
              <span class="corner-bottom-right"></span>
              <h3 :ref="el => titleRefs[2] = el">Reactor 1000</h3>
              <p :ref="el => descRefs[2] = el">Commercial-Scale, GMP</p>
            </div>
          </div>
          <div class="reactor-image">
            <img src="../../assets/image/home/reactor1000.png" alt="Reactor 1000" />
          </div>
          <!-- 人物图片容器 -->
          <div class="reactor-people" v-show="activeReactorIndex === 2">
            <img src="../../assets/image/home/people.png" alt="People" />
          </div>
        </div>

        <!-- Reactor 10000 -->
        <div class="reactor-item reactor-item-4" :class="{ 'active': activeReactorIndex === 3 }"
          @mouseenter="() => handleMouseEnter(3)" @mouseleave="() => handleMouseLeave(3)" @click="() => handleClick(3)"
          :ref="el => reactorRefs[3] = el">
          <div class="reactor-label">
            <div class="reactor-label-corners">
              <span class="corner-top-left"></span>
              <span class="corner-top-right"></span>
              <span class="corner-bottom-left"></span>
              <span class="corner-bottom-right"></span>
              <h3 :ref="el => titleRefs[3] = el">Reactor 10000</h3>
              <p :ref="el => descRefs[3] = el">Commercial-Scale, non-GMP</p>
            </div>
          </div>
          <div class="reactor-image">
            <img src="../../assets/image/home/reactor10000.png" alt="Reactor 10000" />
          </div>
          <!-- 人物图片容器 -->
          <div class="reactor-people" v-show="activeReactorIndex === 3">
            <img src="../../assets/image/home/people.png" alt="People" />
          </div>
        </div>
      </div>
      <div class="product-change" ref="footerRef" v-show="showProductChange">
       <div class="subtitles"> <h3>{{ footerTitle }}</h3><h4 >{{ footerDescription }}</h4></div>
        <p>{{ t("home.reactor.commtext") }}</p>
      </div>

      <div class="footer" v-show="!showProductChange">
        <h2> {{ t("home.reactor.foottitle") }}</h2>
        <p> Pioneer the Next-Gen Technology of High Quality Protein Manufacturing</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick, onUnmounted, watch  } from "vue";
import gsap from "gsap";
import { useI18n } from "vue-i18n";
const { locale, t } = useI18n();
// 反应器数据
const reactors = [
  {
    id: 10,
    name: "Reactor 10",
    description: "Small-Scale, GMP",
    footerTitle: "Reactor 10",
    get footerDescription() { 
      return t('home.reactor.reactor10desco');
    },
  },
  {
    id: 100,
    name: "Reactor 100",
    description: "Pilot-Scale, GMP",
    footerTitle: "Reactor 100",
     get footerDescription() { 
      return t('home.reactor.reactor100desco');
    },
  },
  {
    id: 1000,
    name: "Reactor 1000",
    description: "Commercial-Scale, GMP",
    footerTitle: "Reactor 1000",
   get footerDescription() { 
      return t('home.reactor.reactor1000desco');
    },
  },
  {
    id: 10000,
    name: "Reactor 10000",
    description: "Commercial-Scale, non-GMP",
    footerTitle: "Reactor 10000",
    get footerDescription() { 
      return t('home.reactor.reactor10000desco');
    },
  },
];

const reactorRefs = ref([]);
const titleRefs = ref([]);
const descRefs = ref([]);
const footerRef = ref(null);

// 标题区域引用
const headerRef = ref(null);
const mainTitleRef = ref(null);
const subtitleRef = ref(null);
const descriptionRef = ref(null);
const showProductChange = ref(false);

// 响应式数据
const activeReactorIndex = ref(-1);
const footerTitle = ref("从DNA到蛋白质,无需细胞,生化合成");
const footerDescription = ref("Pioneer the Next-Gen Technology of High Quality Protein Manufacturing");

// 添加 Intersection Observer 监听器
const observer = ref(null);
const headerObserver = ref(null);

// 观察器回调函数
const handleIntersection = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // 元素进入可视区域，触发动画
      const reactor = entry.target;
      const index = reactorRefs.value.indexOf(reactor);
      if (index !== -1) {
        gsap.fromTo(
          reactor,
          {
            opacity: 0,
            y: 50,
            scale: 0.8,
          },
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.8,
            ease: "back.out(1.7)",
            onComplete: () => {
              // 文字打散动画
              if (titleRefs.value[index]) {
                createTextAnimation(titleRefs.value[index]);
              }
              if (descRefs.value[index]) {
                createTextAnimation(descRefs.value[index]);
              }
            }
          }
        );
      }
      // 停止观察（避免重复触发）
      observer.value.unobserve(reactor);
    }
  });
};

const handleHeaderIntersection = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // 标题区域进入可视区域，触发标题动画
      animateHeaderText();
      // 停止观察
      headerObserver.value.unobserve(entry.target);
    }
  });
};

const animateHeaderText = () => {
  // 主标题动画
  if (mainTitleRef.value) {
    const mainTitle = mainTitleRef.value;
    const originalText = mainTitle.textContent;
    mainTitle.textContent = '';

    // 创建字符span
    const chars = originalText.split('').map(char => {
      const span = document.createElement('span');
      span.textContent = char === ' ' ? '\u00A0' : char;
      span.style.display = 'inline-block';
      span.style.opacity = '0';
      span.style.transform = 'translateY(30px)';
      span.style.filter = 'blur(5px)';
      return span;
    });

    chars.forEach(char => mainTitle.appendChild(char));

    // GSAP动画
    gsap.to(chars, {
      opacity: 1,
      y: 0,
      filter: 'blur(0px)',
      duration: 0.8,
      stagger: 0.05,
      ease: "power3.out",
      delay: 0.2
    });
  }

  // 副标题动画
  if (subtitleRef.value) {
    gsap.fromTo(subtitleRef.value,
      {
        opacity: 0,
        y: 20,
        scale: 0.95
      },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.6,
        ease: "back.out(1.7)",
        delay: 0.8
      }
    );
  }

  // 描述文字动画
  if (descriptionRef.value) {
    // 处理换行
    const description = descriptionRef.value;
    const lines = description.innerHTML.split('<br>');
    description.innerHTML = '';

    lines.forEach((line, lineIndex) => {
      const lineDiv = document.createElement('div');
      lineDiv.style.opacity = '0';
      lineDiv.style.transform = 'translateX(-20px)';
      lineDiv.innerHTML = line;
      description.appendChild(lineDiv);

      // 每行文字动画
      gsap.to(lineDiv, {
        opacity: 1,
        x: 0,
        duration: 0.6,
        ease: "power3.out",
        delay: 1.2 + lineIndex * 0.2
      });
    });
  }
};

// 文字打散动画
const createTextAnimation = (element) => {
  if (!element || !element.textContent) return;

  const originalText = element.textContent;
  element.textContent = '';

  // 创建字符span
  const chars = originalText.split('').map(char => {
    const span = document.createElement('span');
    span.textContent = char === ' ' ? '\u00A0' : char;
    span.style.display = 'inline-block';
    span.style.opacity = '0';
    span.style.transform = 'translateY(20px) rotate(10deg)';
    return span;
  });

  chars.forEach(char => element.appendChild(char));

  // GSAP动画
  gsap.to(chars, {
    opacity: 1,
    y: 0,
    rotation: 0,
    duration: 0.6,
    stagger: 0.03,
    ease: "back.out(1.7)",
    delay: 0.2
  });
};

// 点击事件处理（移动端适用）
const handleClick = (index) => {
  // 检查是否为移动端
  if (window.innerWidth <= 768) {
    // 如果点击的是已激活的项，则取消激活
    if (activeReactorIndex.value === index) {
      showProductChange.value = false;
      activeReactorIndex.value = -1;
      footerTitle.value = "从DNA到蛋白质,无需细胞,生化合成";
      footerDescription.value = "Pioneer the Next-Gen Technology of High Quality Protein Manufacturing";
    } else {
      // 设置当前激活的反应器
      activeReactorIndex.value = index;
      showProductChange.value = true;
      footerTitle.value = reactors[index].footerTitle;
      footerDescription.value = reactors[index].footerDescription;
    }

    // 底部文字动画
    if (footerRef.value) {
      gsap.fromTo(footerRef.value,
        {
          opacity: 0,
          y: 20
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          ease: "power3.out"
        }
      );
    }
  }
};

// 鼠标悬停动画
const handleMouseEnter = (index) => {
  if (window.innerWidth <= 768) return;

  console.log('Mouse enter:', index, reactorRefs.value[index]);
  showProductChange.value = true;
  const reactor = reactorRefs.value[index];
  if (!reactor) {
    console.log('Reactor not found:', index);
    return;
  }


  activeReactorIndex.value = index;

  // 更新底部文字
  footerTitle.value = reactors[index].footerTitle;
  footerDescription.value = reactors[index].footerDescription;

  // 放大动画
  gsap.to(reactor, {
    scale: 1.05,
    y: -10,
    duration: 0.3,
    ease: "back.out(1.7)",
  });

  reactorRefs.value.forEach((otherReactor, otherIndex) => {
    if (otherIndex !== index && otherReactor) {
      gsap.to(otherReactor, {
        scale: 0.95,
        duration: 0.3,
        ease: "power2.out",
      });
    }
  });

  // 底部文字动画
  if (footerRef.value) {
    gsap.fromTo(footerRef.value,
      {
        opacity: 0,
        y: 20
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power3.out"
      }
    );
  }
};

const handleMouseLeave = (index) => {
  if (window.innerWidth <= 768) return;

  console.log('Mouse leave:', index);
  showProductChange.value = false;
  const reactor = reactorRefs.value[index];
  if (!reactor) return;

  // 恢复原状
  gsap.to(reactor, {
    scale: 1,
    y: 0,
    duration: 0.3,
    ease: "back.in(1.7)",
  });


  reactorRefs.value.forEach((otherReactor, otherIndex) => {
    if (otherIndex !== index && otherReactor) {
      gsap.to(otherReactor, {
        scale: 1,
        duration: 0.3,
        ease: "power2.out",
      });
    }
  });

  // 重置底部文字
  if (activeReactorIndex.value === index) {
    activeReactorIndex.value = -1;
    footerTitle.value = "从DNA到蛋白质,无需细胞,生化合成";
    footerDescription.value = "Pioneer the Next-Gen Technology of High Quality Protein Manufacturing";

    if (footerRef.value) {
      gsap.to(footerRef.value, {
        opacity: 1,
        y: 0,
        duration: 0.3,
        ease: "power3.out"
      });
    }
  }
};

// 初始化动画
onMounted(() => {
  console.log('Component mounted');

  nextTick(() => {
    // 反应器观察器
    observer.value = new IntersectionObserver(handleIntersection, {
      root: null,
      threshold: 0.1
    });

    reactorRefs.value.forEach((reactor) => {
      if (reactor) {
        observer.value.observe(reactor);
      }
    });

    // 标题观察器
    headerObserver.value = new IntersectionObserver(handleHeaderIntersection, {
      root: null,
      threshold: 0.1
    });

    if (headerRef.value) {
      headerObserver.value.observe(headerRef.value);
    }
  });
});

onUnmounted(() => {
  if (observer.value) {
    observer.value.disconnect();
  }
  if (headerObserver.value) {
    headerObserver.value.disconnect();
  }
});
watch(() => locale.value, () => {
  // 延迟一点时间让DOM更新完成后再执行动画
  setTimeout(() => {
    if (descriptionRef.value) {
      // 清空内容并重新创建动画
      const description = descriptionRef.value;
      const lines = [
        t("home.reactor.sedtitle"),
        t("home.reactor.sedtitle2")
      ];
      
      description.innerHTML = '';
      
      lines.forEach((line, lineIndex) => {
        const lineDiv = document.createElement('div');
        lineDiv.style.opacity = '0';
        lineDiv.style.transform = 'translateX(-20px)';
        lineDiv.textContent = line;
        description.appendChild(lineDiv);
        
        // 每行文字动画
        gsap.to(lineDiv, {
          opacity: 1,
          x: 0,
          duration: 0.6,
          ease: "power3.out",
          delay: lineIndex * 0.2
        });
      });
    }
  }, 0);
})
</script>

<style scoped>
/* 整体容器 */
.reactor-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
}

/* 视频背景 */
.video-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
}

.video-background video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-background::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
}

/* 主内容容器 */
.main-content {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 80px 20px;
}

/* 标题区域 */
.header {
    text-align: left;
    max-width: 100%;
    margin: 0 auto 20px auto;
    width: 100%;
    padding: 2rem 6rem;
}

.header h1 {
  font-size: 3.6rem;
  font-weight: 500;
  margin-bottom: 12px;
  letter-spacing: 0;
  color: #fff;
  line-height: 1.2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  overflow: hidden;
}

.header .subtitle {
  font-size: 20px;
  font-weight: 400;
  opacity: 1;
  margin-bottom: 22px;
  color: #fff;
  letter-spacing: 0;
  line-height: 1.3;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
  transform-origin: left center;
}

.header .description {
  font-size: 16px;
  line-height: 1.8;
  opacity: 0.9;
  color: #fff;
  letter-spacing: 0;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  transform-origin: left center;
}

/* 反应器展示区域 - 桌面端布局 */
.reactors-section {
    margin: 3rem 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 32px;
    padding: 45px 1rem;
    position: relative;
}

.reactor-item {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  transition: transform 0.3s ease, opacity 0.3s ease;
  cursor: pointer;
  position: relative;
}
.gmp-icon{
  width: 8rem;
  position: absolute;
  right: 6rem;
  top: 6rem;
}

/* Reactor-item hover 动画效果 - 仅在PC端生效 */
@media (min-width: 769px) {
  .reactor-item:hover {
    transform: translateY(-5px);
  }

  .reactor-item:hover .reactor-image img {
    transform: scale(1.05);
    transition: transform 0.3s ease;
  }

  .reactor-item:hover .corner-top-left,
  .reactor-item:hover .corner-top-right,
  .reactor-item:hover .corner-bottom-left,
  .reactor-item:hover .corner-bottom-right {
    border-color: rgba(255, 255, 255, 1);
    filter: drop-shadow(0 0 3px rgba(255, 255, 255, 0.8));
  }
}

/* 激活状态下的层级调整 */
.reactor-item.active {
  z-index: 100 !important;
}

.reactor-label {
  text-align: center;
  margin-bottom: 18px;
  width: fit-content;
  margin-bottom: 20px;
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.reactor-label-corners {
  width: fit-content;
  padding: 0.8rem;
  margin-right: -6rem;
  position: relative;
  display: inline-block;
}

/* 四个独立的L形角括号装饰 */
.corner-top-left,
.corner-top-right,
.corner-bottom-left,
.corner-bottom-right {
  position: absolute;
  width: 10px;
  height: 10px;
  border: 2px solid #fff;
  pointer-events: none;
  transition: all 0.3s ease;
}

/* 左上角 */
.corner-top-left {
  left: 0;
  top: 0;
  border-right: none;
  border-bottom: none;
}

/* 右上角 */
.corner-top-right {
  right: 0;
  top: 0;
  border-left: none;
  border-bottom: none;
}

/* 左下角 */
.corner-bottom-left {
  left: 0;
  bottom: 0;
  border-right: none;
  border-top: none;
}

/* 右下角 */
.corner-bottom-right {
  right: 0;
  bottom: 0;
  border-left: none;
  border-top: none;
}

.reactor-label h3 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 6px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6);
  position: relative;
  display: inline-block;
  color: #fff;
  letter-spacing: 0;
  line-height: 1.2;
  white-space: nowrap;
  z-index: 1;
}

.reactor-label p {
  font-size: 16px;
  opacity: 0.9;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6);
  text-align: center;
  width: 100%;
  margin: 0 auto;
  color: #fff;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0;
  position: relative;
  z-index: 1;
}

.reactor-image {
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

/* 不同尺寸的反应器 - 桌面端布局 */
.reactor-item-1 {
  height: 240px;
  width: 560px;
  position: relative;
  z-index: 30;
  margin-right: -160px;
  margin-bottom: 24px;
}

.reactor-item-2 {
  height: 220px;
  width: 1400px;
  position: relative;
  z-index: 20;
  margin-right: -230px;
  margin-bottom: 24px;
}

.reactor-item-3 {
  height: 220px;
  width: 1400px;
  position: relative;
  margin-right: -310px;
  margin-bottom: 24px;
  box-sizing: border-box;
  z-index: 40;
}

.reactor-item-4 {
  height: 340px;
  width: 2400px;
  z-index: 10;
}

/* 反应器图片 */
.reactor-image img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  transition: transform 0.3s ease;
}

/* 人物图片样式 */
.reactor-people {
  position: absolute;
  right: 0px;
  width: 5rem;
  top: 10rem;
  height: auto;
  z-index: 1000;
  pointer-events: none;
}

.reactor-people img {
  width: 100%;
  height: auto;
  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.3));
}

/* 底部文字 */
.footer {
  text-align: center;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  transition: all 0.5s ease;
}

.footer h2 {
  font-size: 3.4rem;
  font-weight: 500;
  margin-bottom: 12px;
  letter-spacing: 0;
  color: #fff;
  line-height: 1.2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.footer p {
  font-size: 18px;
  opacity: 1;
  font-weight: 400;
  color: #fff;
  letter-spacing: 0;
  line-height: 1.4;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
  max-width: 800px;
  margin: 0 auto;
}

.product-change {
  color: #fff;
    text-align: left;
    margin: 0 auto;
    width: 100%;
    padding: 0 6rem;
}
.subtitles{
  display: flex;
  align-items: center;
  gap: 2rem;
}
.subtitles h4{
  font-size: 1.6rem;
  font-weight: 600;
}
.product-change h3 {
  font-size: 2.6rem;
  margin-bottom: 10px;
  font-weight: 600;
}

.product-change p {
  font-size: 1.4rem
}
/* 桌面端响应式调整 */
@media (max-width: 1200px) {
  .main-content {
    padding: 60px 20px;
  }

  .header h1 {
    font-size: 3.2rem;
  }

  .footer h2 {
    font-size: 3rem;
  }

  .reactors-section {
    gap: 20px;
    padding: 30px 0;
  }

  .reactor-people {
    right: -120px;
    width: 150px;
  }
}

@media (max-width: 768px) {
  .main-content {
    padding: 6rem 1.5rem;
    justify-content: flex-start;
  }

  .header {
    text-align: center;
    margin-bottom: 0;
    padding: 2rem;
  }

  .header h1 {
    font-size: 2.2rem;
    text-align: left;
  }

  .header .subtitle {
    font-size: 1.6rem;
    text-align: left;
  }

  .header .description {
    font-size: 1.4rem;
    text-align: left;
  }

  .reactors-section {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 0;
    padding: 20px 0;
    margin-bottom: 0;
    margin-top: 3rem;
  }
  .gmp-icon{
    width: 6rem;
    top:18rem;
    right:3rem;
    display: none;
  }

  /* 反应器项 - 每行两个 */
  .reactor-item {
    width: calc(50% - 10px) !important;
    height: auto !important;
    max-width: none;
    margin: 0 !important;
    padding: 20px 0;
    transform: none !important;
  }

  /* 移除所有负边距和重叠 */
  .reactor-item-1,
  .reactor-item-2,
  .reactor-item-3,
  .reactor-item-4 {
    margin-right: 0 !important;
    margin-left: 0 !important;
    margin-bottom: 0 !important;
    position: relative;
    z-index: 1;
  }

  /* 修复标签样式 */
  .reactor-label-corners {
    margin-right: 0;
    padding: .6rem;
  }

  .reactor-label h3 {
    font-size: 2rem;
    white-space: normal;
    text-align: center;
  }

  .reactor-label p {
    font-size: 1.4rem;
    white-space: normal;
    text-align: center;
  }

  /* 反应器图片调整 */
  .reactor-image {
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .reactor-image img {
    max-height: 100%;
    width: auto;
    max-width: 100%;
  }

  /* 隐藏人物图片 */
  .reactor-people {
    display: none;
  }

  /* 底部文字调整 */
  .footer {
    text-align: center;
  }

  .footer h2 {
    font-size: 2.4rem;
  }

  .footer p {
    font-size: 1.6rem;
  }

  .product-change {
    padding-left: 0;
    text-align: center;
  }

  .product-change h3 {
    font-size: 2.2rem;
  }

  .product-change p {
    font-size: 1.4rem;
    line-height: 1.5;
  }
}

/* 小屏幕手机进一步优化 */
@media (max-width: 480px) {
  .main-content {
    padding: 4rem 1rem;
  }

  .header h1 {
    font-size: 2.2rem;
  }

  .header .subtitle {
    font-size: 1.4rem;
  }

  .header .description {
    font-size: 1.2rem;
  }

  .reactors-section {
    gap: 15px;
  }

  .reactor-item {
    width: calc(50% - 8px) !important;
  }

  .reactor-image {
    height: 160px;
  }

  .reactor-label h3 {
    font-size: 1.8rem;
  }

  .reactor-label p {
    font-size: 1.2rem;
  }

  .footer h2 {
    font-size: 2rem;
  }

  .footer p {
    font-size: 1.4rem;
  }

  .product-change h3 {
    font-size: 1.8rem;
  }

  .product-change p {
    font-size: 1.2rem;
  }
}

/* 超小屏幕适配 */
@media (max-width: 360px) {
  .header h1 {
    font-size: 2rem;
  }

  .reactor-item {
    width: calc(50% - 5px) !important;
  }

  .reactor-image {
    height: 140px;
  }
}
@media screen and (min-width: 1920px) {
  .reactors-section{
    margin:4rem auto 3rem auto;
    padding: 3rem 4rem;
  }
}

</style>